import { Button } from '../ui/button';
import { History } from 'lucide-react';

const timeAgo = (ts) => { const m = Math.round((Date.now() - ts) / 60000); return m < 1 ? "à l'instant" : m < 60 ? `il y a ${m} min` : `il y a ${Math.round(m / 60)} h`; };

export const DraftBanner = ({ draft, onRestore, onDiscard }) => (
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 rounded-lg border border-amber-500/30 bg-amber-500/10 px-4 py-3" data-testid="draft-restore-banner">
          <div className="flex items-center gap-3 text-sm">
            <History className="w-5 h-5 text-amber-400 shrink-0" />
            <div>
              <p className="font-medium">Brouillon non sauvegardé trouvé <span className="text-muted-foreground font-normal">({timeAgo(draft.savedAt)})</span></p>
              <p className="text-xs text-muted-foreground">{draft.titre || 'Sans titre'} · {draft.questions?.filter(q => q.texte).length || 0} question(s) saisie(s)</p>
            </div>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <Button size="sm" variant="outline" onClick={onDiscard} data-testid="draft-discard-btn">Ignorer</Button>
            <Button size="sm" onClick={onRestore} className="bg-amber-500 text-black hover:bg-amber-400" data-testid="draft-restore-btn"><History className="w-4 h-4 mr-1.5" /> Restaurer</Button>
          </div>
        </div>
);
